import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponentComponent } from './components/main-component/main-component.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponentComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/client.module').then((m) => m.ClientModule),
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule { }
